import {Parser} from "sparqljs";

export function restructureResponse(data) {
  let items = (data && data.results.bindings) || [];
  items = items.map(item => {
    let res = {};
    Object.keys(item).forEach(key => {
      res[key] = item[key].value;
    });
    return res;
  });

  return items;
};


export function aggregateResultsByFirstParameter(restructuredData,id)
{
  let items=(restructuredData) ||[];
  var id_item={};
   for (var n in items)
   {
     var item=items[n];
      var gitem=id_item[item[id]];
      if (gitem==null){gitem=item; id_item[item[id]]=gitem; }
      else{
        // aggregeren maar
         for (var key in item)
         {
           gitem[key]=item[key];
          
         }

      }
   }


   return Object.values(id_item);
}



window.top.downloadObjectAsJson=function(exportObj, exportName){
  var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(JSON.stringify(exportObj));
  var downloadAnchorNode = document.createElement('a');
  downloadAnchorNode.setAttribute("href",     dataStr);
  downloadAnchorNode.setAttribute("download", exportName + ".json");
  document.body.appendChild(downloadAnchorNode); // required for firefox
  downloadAnchorNode.click();
  downloadAnchorNode.remove();
}

window.top.downloadMe=function()
{
  window.top.downloadObjectAsJson(window.top.data,"config");

}

window.top.downloadCache=function()
{
  window.top.downloadObjectAsJson(window.top.cache,"cache");

}




export function generateEmptyResponse(sparql)
{
  var sp= new Parser();
  var parsed=null;
  try
  {
  if (sparql==null) {  sparql="select ?a ?aURI ?c where {?a ?aURI ?c}";}
   var sparql2=sparql.replace(new RegExp("<{{", 'g'), "<http://").replace(new RegExp("}}>", 'g'), ".nl>");
    parsed=sp.parse(sparql2);
    
    
   }
   catch(eee)
   {
    var sparql2="select ?a ?aURI ?c where {?a ?aURI ?c}";
     parsed=sp.parse(sparql2);
   }
   
   
   var vars=parsed.variables;
   

  
var empty= { "head": { "vars": []}};
empty.results={bindings:[]};
var bindings = empty.results.bindings;
var record = {};
bindings.push(record);
for (var n in vars)
{
  if (Array.isArray(vars[n]))
  {
    var v=vars[n].slice(1);
  }
  else
  {
   
    v=vars[n].variable;
    if (v==null){v=vars[n]};
    v=v.replace("?","");
    
  }
  empty.head.vars.push(v);
  if (v.endsWith("URI"))
  {
    record[v]={"type":"uri","value":"http://www.example.org/5c3c96ea1d83d8396b87bc0b"};
  }
  else
  {
    record[v]={"type":"literal","value":""};
  }
}

   
return empty;
}

window.top.generateEmptyResponse=function()
{
  generateEmptyResponse(null);
}